import { render, staticRenderFns } from "./LossLocation.vue?vue&type=template&id=65ae7b17"
import script from "./LossLocation.vue?vue&type=script&lang=js"
export * from "./LossLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports